
import { mapGetters } from "vuex";
import { getCroppedImageUrl } from "~/common/helpers";

export default {
  props: {
    profile: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      dateFormatOptions: {
        year: "numeric",
        month: "long",
        day: "numeric",
      },
    };
  },

  computed: {
    ...mapGetters({
      discreetMode: "getDiscreetStatus",
    }),

    photo() {
      return getCroppedImageUrl(
        this.profile.mainPhoto,
        "494x408",
        this.discreetMode
      );
    },

    age() {
      return this.profile.myDetails?.at(0).age;
    },

    city() {
      return this.profile.location[0].baseCity;
    },

    authorPhoto() {
      return this.profile?.review?.user?.photo;
    },

    authorName() {
      return this.profile?.review?.user?.name;
    },

    date() {
      return this.profile?.review?.created_at;
    },

    reviewText() {
      return this.profile?.review?.text;
    },
  },
};
